/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Range_ApplyInputs */

const en_shopping_range_apply = /** @type {(inputs: Shopping_Range_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const de_shopping_range_apply = /** @type {(inputs: Shopping_Range_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übernehmen`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Shopping_Range_ApplyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_range_apply = /** @type {((inputs?: Shopping_Range_ApplyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Range_ApplyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_range_apply(inputs)
	return en_shopping_range_apply(inputs)
});